module.exports = __webpack_public_path__ + "media/two.c6a8a9c6.mp3";